module.exports = "<h1 id=\"aa\">Angular2 Dashboard</h1>\r\n\r\n<div class=\"jumbotron\">\r\n    <h2>Welcome to Northwind - Angular 2.0 Web application</h2>\r\n    <p class=\"lead\">This application was generated using CodeBhagat source code generator for .NET. You can download CodeBhagat for .NET and use an Application generator to jump-start your new Angular 2.0 Web applications*.</p>\r\n    <p><a href=\"http://www.codebhagat.com\" class=\"btn btn-primary btn-lg\">Learn more &raquo;</a></p>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.html
// module id = 1139
// module chunks = 1